import lockScroll from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class VideoGallery {
	constructor() {
		this.lightboxOpen = $('.video-gallery__card, .video-button');
		this.lightboxClose = $('.video-gallery__close');
		this.lightbox = $('.video-gallery__lightbox');
	}

	init() {
		if (!$('.block-video-gallery, .video-button').length) {
			return;
		}

		this.bindEvents();
	}

	bindEvents() {
		this.lightboxOpen.on('click', this.openLightbox);
		this.lightboxClose.on('click', this.closeLightbox);
		this.lightbox.on('click', this.clickLightbox);
	}

	openLightbox(e) {
		e.preventDefault();
		const id = e.currentTarget.getAttribute('data-id');
		const embedUrl = e.currentTarget.getAttribute('data-embed-url');
		const ratio = e.currentTarget.getAttribute('data-ratio');
		const lightbox = $(`#video-gallery-lightbox-${id}`);

		lightbox
			.find('.video-gallery__iframe-wrapper')
			.css('padding-top', `${ratio}%`);
		lightbox.find('iframe').attr('src', embedUrl);

		lightbox.addClass('active').attr('aria-hidden', 'false');
		lockScroll.lock();
	}

	closeLightbox() {
		const lightbox = $(this).parent('.video-gallery__lightbox');
		lightbox.find('iframe').attr('src', '');
		lightbox.removeClass('active').attr('aria-hidden', 'true');
		lockScroll.unlock();
	}

	clickLightbox(e) {
		const lightbox = $(this);
		if (
			e.target === e.currentTarget ||
			$(e.target).closest('.container').length
		) {
			lightbox.find('iframe').attr('src', '');
			lightbox.removeClass('active').attr('aria-hidden', 'true');
			lockScroll.unlock();
		}
	}
}
export default new VideoGallery();
